module.exports = __webpack_public_path__ + "img/person-dress-simple.879e73aa.svg";